document.addEventListener('click', function(event) {
  const btn = event.target.closest('.wishlist-toggle');
  if (!btn) return;

  const handle = btn.dataset.productHandle;
  const title = btn.dataset.productTitle;
  const url = btn.dataset.productUrl;

  if (!handle) return;

  const key = 'wishlist';
  let list;

  try {
    list = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(list)) list = [];
  } catch (e) {
    list = [];
  }

  const index = list.findIndex(function(item) { return item.handle === handle; });

  if (index === -1) {
    list.push({ handle: handle, title: title, url: url });
  } else {
    list.splice(index, 1);
  }

  localStorage.setItem(key, JSON.stringify(list));
});
